import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantFieldGroupTemplate } from '../mutations/createParticipantFieldGroupTemplate.mutation';
import type {
  CreateParticipantFieldGroupTemplateMutation,
  CreateParticipantFieldGroupTemplateMutationVariables,
} from '../types';

export const useCreateParticipantFieldGroupTemplateMutation = (
  options?: MutationOptions<
    CreateParticipantFieldGroupTemplateMutation,
    CreateParticipantFieldGroupTemplateMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantFieldGroupTemplate), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participantFieldGroupTemplates'),
      });
    },
  });
};
